// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__3X9UK","savePackageButton":"ClientWallet_savePackageButton__2RzDy"};